import type { BoxProps } from "@chakra-ui/react"
import { Box } from "@chakra-ui/react"

import DOMPurify from "isomorphic-dompurify"

export function SanitizedContent({
  sx,
  content,
  ...rest
}: BoxProps & { content: string | null | undefined }) {
  return (
    <Box
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content || ""),
      }}
      w="100%"
      sx={{
        h2: {
          marginTop: "1.5rem",
          marginBottom: "1rem",
        },

        h3: {
          marginTop: "1rem",
          marginBottom: "1rem",
        },

        "ul, ol": {
          marginBottom: "1rem",
          paddingInlineStart: "1rem",
        },

        a: {
          fontSize: "inherit",
          textDecoration: "underline",
        },
        ...sx,
      }}
      {...rest}
    />
  )
}
